<template>
  <div id="pers-tab2-7" name="hrms32e-tab2-tab7" class="content-pers-table">
    <hrms-table :columns="detail2Tab7Table"
                :data="detail"
                :maxRowspan="maxRowspanDetail6"
                :addInlineEventBool="true"
                :editInlineEventBool="true"
                :deleteInlineEventBool="true"
                :deleteInlineBtnDisp="false"
                :saveInlineBtnDisp="validateStaappr"
                :saveInlineEvent="callSave"
                :flgToggle="personalDataActive" />

    <div class="col-md-12 box-footer">
      <button type="button" class="btn bg-dark-gray pull-left" @click="togglePage(0)" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
    </div>

  </div>
</template>

<script>
import detailTemplate from 'components/hrms32e/detailTemplate'

export default {
  name: 'hrms32e-tab2-tab7',
  data () {
    return {
      subTopic1: true,
      subTopic2: true
    }
  },
  watch: {
    detail () {
      this.$nextTick(() => {
        this.errors.clear()
      })
    }
  },
  methods: {
    callSave (dataRowsHasFlg) {
      this.$validator.validateAll().then(result => {
        if (result && this.searchDetail.codempid_query !== '') {
          let param = {
            p_codempid: this.indexSelected.codempid,
            p_dtereq: this.searchDetail.dtereq,
            p_numseq: this.indexSelected.numseq,
            p_codempid_query: this.searchDetail.codempid_query
          }
          for (var i = 0; i < dataRowsHasFlg.length; i++) {
            dataRowsHasFlg[i] = Object.assign(dataRowsHasFlg[i], param)
          }
          this.postDetail2Tab7Save({ saveParams: dataRowsHasFlg, searchIndex: this.searchIndex, togglePage: this.togglePage })
        }
      })
    }
  },
  props: [ 'nowLang',
    'labels',
    'detail',
    'pcDisp',
    'togglePage',
    'toggleSubPage',
    'triggerSubButton',
    'deleteDocuments',
    'labelsButton',
    'dropdowns',
    'detail2Tab7Table',
    'postDetail2Tab7Save',
    'indexSelected',
    'searchDetail',
    'searchIndex',
    'personalDataActive',
    'validateStaappr'
  ],
  components: {
    detailTemplate
  }
}

</script>



// WEBPACK FOOTER //
// tab2_7.vue?fe7ac162